var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9479 5.59674C16.1594 4.24003 14.1155 3.5 12 3.5C8.39242 3.5 5.03014 5.63785 2.68983 9.33798C1.77006 10.7872 1.77006 13.2231 2.68983 14.6724C3.49719 15.9468 4.4374 17.0466 5.45937 17.9305M8.34141 19.7394C9.50645 20.2328 10.743 20.5 12 20.5C15.6076 20.5 18.9699 18.3621 21.3102 14.662C22.2299 13.2128 22.2299 10.7769 21.3102 9.32765C20.9729 8.79319 20.605 8.28956 20.2269 7.81677M15.5871 12.7195C15.3214 14.1687 14.1461 15.3507 12.7051 15.6179M11.7139 12.2879L4.07974 19.9656M19.9203 4.03448L12.2862 11.7122M14.5856 9.39959L9.41448 14.6003C8.75019 13.9323 8.34141 13.0175 8.34141 12C8.34141 9.96491 9.97652 8.32039 12 8.32039C13.0118 8.32039 13.9213 8.73151 14.5856 9.39959Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.bf3530087530c47fc2f0a41d05427695.svg";
export { ForwardRef as ReactComponent };